import { Star, BadgeCheck } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { TESTIMONIALS } from "../constants/site";

export const Testimonials = () => (
    <section
        id="depoimentos"
        className="border-y border-[#222232] bg-[#0E0E14] py-20 md:py-28"
        data-testid="testimonials-section"
    >
        <div className="mx-auto max-w-7xl px-5 md:px-8">
            <Reveal className="max-w-2xl">
                <Eyebrow>Depoimentos</Eyebrow>
                <h2 className="mt-5 text-3xl font-bold text-white sm:text-4xl">
                    Quem assiste, aplaude de pé.
                </h2>
                <p className="mt-4 text-base leading-relaxed text-[#94A3B8] md:text-lg">
                    Isso é o que os nossos assinantes dizem depois de trocar
                    várias assinaturas caras por um único acesso.
                </p>
            </Reveal>

            <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-3">
                {TESTIMONIALS.map((t, i) => (
                    <Reveal key={t.name} delay={i * 0.08} className="h-full">
                        <figure
                            data-testid={`testimonial-card-${i}`}
                            className="flex h-full flex-col rounded-3xl border border-[#222232] bg-[#14141E] p-7 transition-all duration-300 hover:-translate-y-1.5 hover:border-[#E50914]/40"
                        >
                            <div className="flex gap-1">
                                {Array.from({ length: 5 }).map((_, s) => (
                                    <Star
                                        key={s}
                                        className="h-4 w-4 text-[#FFB800]"
                                        fill="currentColor"
                                    />
                                ))}
                            </div>
                            <blockquote className="mt-4 flex-1 text-base leading-relaxed text-[#94A3B8]">
                                “{t.quote}”
                            </blockquote>
                            <figcaption className="mt-6 flex items-center gap-3">
                                <span className="grid h-11 w-11 place-items-center rounded-full border border-[#E50914]/30 bg-[#E50914]/10 font-display text-sm font-extrabold text-[#FF4757]">
                                    {t.name[0]}
                                </span>
                                <div>
                                    <p className="text-sm font-bold text-white">
                                        {t.name}
                                    </p>
                                    <p className="flex items-center gap-1 text-xs font-semibold text-[#64748B]">
                                        <BadgeCheck className="h-3.5 w-3.5 text-[#25D366]" />
                                        {t.city} • assinante verificado
                                    </p>
                                </div>
                            </figcaption>
                        </figure>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
